import {Component, computed, input} from '@angular/core';
import {NgClass} from '@angular/common';
import {Chip} from 'primeng/chip';
import {TranslocoDirective} from '@jsverse/transloco';
import {HrToolAiCapabilityView} from '@frontend/shared-api';
import {AiCapabilityLabelComponent} from '../ai-capability-label/ai-capability-label.component';
import {AiCapabilityDotsComponent} from '../ai-capability-dots/ai-capability-dots.component';
import {AiCapabilityLevelLabelComponent} from '../ai-capability-level-label/ai-capability-level-label.component';
import {DirectusTooltipComponent} from '../directus-tooltip/directus-tooltip.component';
import {buildAiProfileRows} from '../../utils/hr-tool-ai-capability.utils';
import {AiProfileViewRow} from './hr-tool-ai-profile-view.types';

@Component({
  selector: 'app-hr-tool-ai-profile-view',
  imports: [
    NgClass,
    Chip,
    TranslocoDirective,
    AiCapabilityLabelComponent,
    AiCapabilityDotsComponent,
    AiCapabilityLevelLabelComponent,
    DirectusTooltipComponent,
  ],
  templateUrl: './hr-tool-ai-profile-view.component.html',
})
export class HrToolAiProfileViewComponent {
  protected readonly gridColumns =
    'md:grid-cols-[minmax(12rem,1.3fr)_6rem_minmax(7rem,0.9fr)_minmax(0,2.6fr)]';

  readonly profile = input<HrToolAiCapabilityView[] | undefined>([]);
  readonly toolName = input('');

  protected readonly rows = computed<AiProfileViewRow[]>(() =>
    buildAiProfileRows(this.profile()).map((row) => ({
      ...row,
      hasUseCases: row.useCases.length > 0,
      testId: `ai-profile-${row.capability}`,
    })),
  );
  protected readonly hasRows = computed(() => this.rows().length > 0);
  protected readonly nameParams = computed(() => ({name: this.toolName()}));
}
